import { combineReducers } from "redux";
import stepOneReducer from "./steps/stepOneSlice";
import stepFourReducer from "./steps/stepFourSlice";
import stepFiveReducer from "./steps/stepFiveSlice";

const createReducer: any = () =>
  combineReducers({
    stepOne: stepOneReducer,
    stepFour: stepFourReducer,
    stepFive: stepFiveReducer,
  });
export default createReducer;
